import { editorial } from './editorialData';
import { flattenFragments, wordCount } from './parseConteudos';

export function chapterByKey(key) {
  return editorial.chapters.find((chapter) => chapter.key === key) || null;
}

export function spokenSteps(chapter) {
  return flattenFragments(chapter).map((fragment, index, all) => ({
    name: `${chapter.key}-${index}`,
    text: fragment.spoken,
    triggers: [index === all.length - 1 ? 'finish' : `reveal-${index + 1}`],
  }));
}

export const SHORT_STEP_LIMIT = 12;

export function shortSteps() {
  return editorial.chapters.flatMap((chapter) => (
    flattenFragments(chapter)
      .filter((fragment) => wordCount(fragment.spoken) < SHORT_STEP_LIMIT)
      .map((fragment) => ({
        chapter: chapter.key,
        title: chapter.title.replace(/\n/g, ' '),
        spoken: fragment.spoken,
        words: wordCount(fragment.spoken),
      }))
  ));
}
